import request from './request';
import deserialize from './deserialize';

export type Profile = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  allowedStores: string[];
  role: string;
};

export function get() {
  return request<Profile>({
    url: 'companion/v1/profile',
    method: 'GET',
    transformResponse: deserialize,
  });
}
